module.exports = __webpack_public_path__ + "img/closeIcon.cdc3fb67.png";